module.exports = __webpack_public_path__ + "img/map_1791549390197_2900.3dc7349a.jpg";